import styled from "styled-components";

export const OpacityWrapper = styled.div<{ disabled: boolean }>(({ disabled }) => ({
    opacity: disabled ? 0.7 : 1,
}));
